'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import MarketingNavigation from './MarketingNavigation';
import MarketingFooter from './MarketingFooter';

/**
 * Wraps marketing pages in the shared nav and footer, except on routes that
 * deliberately ship their own minimal chrome.
 *
 * Standalone landing pages — `/us/enroll` is one — are paid-traffic squeeze
 * pages. They carry their own logo header and their own slim footer, and they
 * omit site navigation on purpose: every extra link is a way out of the funnel.
 * Wrapping one in the full nav stacks two headers and undoes that.
 *
 * A Next.js nested layout wraps inside its parent rather than replacing it, so
 * a child route cannot opt out on its own. The alternative is a route group,
 * which would mean physically moving ten page directories. This is the smaller
 * change and states the intent in one place.
 */
const BARE_ROUTES = ['/us/enroll'];

export default function MarketingChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname() ?? '';
  const isBare = BARE_ROUTES.some(route => pathname === route || pathname.startsWith(route + '/'));

  if (isBare) return <>{children}</>;

  return (
    <div className="min-h-screen flex flex-col">
      <MarketingNavigation />
      <main className="flex-grow">{children}</main>
      <MarketingFooter />
    </div>
  );
}
